const imgUrl = {
    'logo' : require('./logo.png'),
    'poweredby' : require('./powered-by.png'),
    'stoptblogo' : require('./stoptb_logo.png'),
    'mapdefult' : require('./marker/default_nearme.svg'),
    'accessbility' : require('./services/hospital.svg'), 
    'tour-guide' : require('./tour-guide.png'),
    'microphone' : require('./microphone-black-shape.svg'),
    'micicon' : require('./mic.png'),
    'settings' : require('./settings.png'),
    'neame' : require('./neame.png'),
    'langicon' : require('./language.png'),
    'qaulity' : require('./services/unacceptable.svg'),
}

export default imgUrl;